import { all, fork, takeEvery } from 'redux-saga/effects';
import { deleteEntity, loadEntities, showErrorMessage, updateEntity } from 'helpers/utilHelpers';
import { dadata } from 'util/config';
import { DELETE_LEGAL_ENTITY, LOAD_DADATA, LOAD_LEGAL_ENTITIES, UPDATE_LEGAL_ENTITY } from 'constants/ActionTypes';

function* loadLegalEntities() {
  yield takeEvery(LOAD_LEGAL_ENTITIES, loadEntities);
}

function* fetchDadata(action) {
  const fetchResource = () => {
    const init = {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Token ' + dadata.token,
      },
      body: JSON.stringify({
        query: action.payload.query,
      }),
    };

    return fetch(dadata.url, init).then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        return {
          errorCode: res.status,
          errorContent: action.payload.onErrorMessage,
        };
      }
    });
  };

  try {
    const response = yield fetchResource();
    if (!response.errorCode) {
      action.payload.onSuccess(response.suggestions[0]);
    } else {
      yield showErrorMessage(response);
    }
  } catch {
    yield showErrorMessage(action.payload.onErrorMessage);
  }
}

function* loadDadata() {
  yield takeEvery(LOAD_DADATA, fetchDadata);
}

function* updateLegalEntities() {
  yield takeEvery(UPDATE_LEGAL_ENTITY, updateEntity);
}

function* deleteLegalEntities() {
  yield takeEvery(DELETE_LEGAL_ENTITY, deleteEntity);
}

export default function* rootSaga() {
  yield all([fork(loadDadata), fork(loadLegalEntities), fork(updateLegalEntities), fork(deleteLegalEntities)]);
}
